import React, { useState, useEffect } from "react";
import { OTSession, OTPublisher, OTStreams, OTSubscriber } from "opentok-react";
import "@opentok/client";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideocamOffIcon from "@material-ui/icons/VideocamOff";
import { useLocation, useNavigate } from "react-router-dom";

import { startSession } from "apiHandler/actions";
import { isAuthenticated } from "apiHandler/actions/auth";
import Loading from "components/modals/Loading";
import { IconButton } from "@mui/material";

const App = () => {
  const [error, setError] = useState(null);
  const [connection, setConnection] = useState("Connecting");
  const [publishVideo, setPublishVideo] = useState(true);
  const [apiKey, setApiKey] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [token, setToken] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const sessionEventHandlers = {
    sessionConnected: () => setConnection("Connected"),
    sessionDisconnected: () => setConnection("Disconnected"),
    sessionReconnected: () => setConnection("Reconnected"),
    sessionReconnecting: () => setConnection("Reconnecting"),
  };

  const publisherEventHandlers = {
    accessDenied: () => {
      console.log("User denied access to media source");
    },
    streamCreated: () => {
      console.log("Publisher stream created");
    },
    streamDestroyed: ({ reason }) => {
      console.log(`Publisher stream destroyed because: ${reason}`);
    },
  };

  const subscriberEventHandlers = {
    videoEnabled: () => {
      console.log("Subscriber video enabled");
    },
    videoDisabled: () => {
      console.log("Subscriber video disabled");
    },
  };

  useEffect(() => {
    const auth_data = isAuthenticated();
    const publisher_uuid = auth_data?.uuid;
    const participant_uuid = location?.data?.uuid;
    const appointment_id = location?.data?.appntId;

    if (!participant_uuid || !publisher_uuid || !appointment_id) {
      navigate("/appointments", { replace: true });
    } else {
      const payload = {
        user_role: "publisher",
        access_key: "b70m4gwtMtQHWhOFMdkb", // To do : need to change later
        publisher_uuid,
        participant_uuid,
        appointment_id,
      };
      const fetchSessionData = async () => {
        const result = await startSession(payload, auth_data?.id_token);
        setApiKey(result.video_api_key);
        setSessionId(result.session_id);
        setToken(result.token);
      };
      fetchSessionData();
    }
  }, [navigate, location]);

  const onSessionError = (error) => {
    setError(error);
  };

  const onPublish = () => {
    console.log("Publish Success");
  };

  const onPublishError = (error) => {
    setError(error);
  };

  const onSubscribe = () => {
    console.log("Subscribe Success");
  };

  const onSubscribeError = (error) => {
    setError(error);
  };

  const toggleVideo = () => {
    setPublishVideo((prevState) => !prevState);
  };

  if (!apiKey && !sessionId && !token) return <Loading />;

  return (
    <div>
      <div id="sessionStatus">
        <span style={{ fontSize: 16, fontWeight: 500 }}>Status: </span>
        <span
          style={{
            fontSize: 16,
            fontWeight: 400,
            color: connection === "Connected" ? "green" : "red",
          }}
        >
          {connection}
        </span>
        {publishVideo ? (
          <IconButton onClick={toggleVideo}>
            <VideocamOffIcon fontSize="medium" />
          </IconButton>
        ) : (
          <IconButton onClick={toggleVideo}>
            <VideocamIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
      {error && (
        <div className="error">
          <strong>Error:</strong> {error.message || error}
        </div>
      )}
      <OTSession
        apiKey={apiKey}
        sessionId={sessionId}
        token={token}
        onError={onSessionError}
        eventHandlers={sessionEventHandlers}
      >
        <OTPublisher
          properties={{ publishVideo, width: 1200, height: 550 }}
          onPublish={onPublish}
          onError={onPublishError}
          eventHandlers={publisherEventHandlers}
        />
        <OTStreams>
          <OTSubscriber
            properties={{ width: 100, height: 100 }}
            onSubscribe={onSubscribe}
            onError={onSubscribeError}
            eventHandlers={subscriberEventHandlers}
          />
        </OTStreams>
      </OTSession>
    </div>
  );
};

export default App;
